import { useRef } from 'react';
import { useEventCallback } from '../useEventCallback';
/**
 * Provide user trigger `onKeyDown` only one time when hold press on key.
 * @param includeKeys that check include keys
 * @param methods trigger when first keydown or keyup
 * @returns
 */
export var useKeyDownOnce = function (includeKeys, _a) {
    var onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp;
    var isKeyDownMapRef = useRef({});
    var handleKeyDown = useEventCallback(function (e) {
        if (includeKeys.includes(e.key)) {
            if (!isKeyDownMapRef.current[e.key]) {
                onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
            }
            else {
                e.preventDefault();
                e.stopPropagation();
            }
            isKeyDownMapRef.current[e.key] = true;
        }
        else {
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        }
    });
    var handleKeyUp = useEventCallback(function (e) {
        if (includeKeys.includes(e.key)) {
            isKeyDownMapRef.current[e.key] = false;
        }
        onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(e);
    });
    return {
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
    };
};
